import { createRouter, createWebHistory, createWebHashHistory } from "vue-router";

import indexRouter from './modules/index'  //首页
import baseInfoRouter from './modules/baseInfo'  //基础信息管理
import managerRouter from './modules/manager'  //基础信息管理

export const constantRouterMap = [
  {
    path: '/redirect',
    hidden: true,
    meta: {},
    children: [
      {
        path: '/redirect/:path*',

        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/index',
    component: () => import('@/views/index/index'),
    name: 'index',
    meta: { title: '首页', icon: '', noCache: true }
  }, {
    path: '/',
    name: 'login',
    title: '登录',
    meta: {
      showNav: true
    },
    component: () => import('@/views/login/index')
  },
  //草稿箱
  {
    path: '/copyBox',
    component: () => import('@/views/index/copyBox'),
    name: 'copyBox',
    meta: { title: '草稿箱', icon: '', noCache: true },
  },
  {
    path: '/user',
    component: () => import('@/views/system/user'),
    name: 'user',
    meta: { title: '人员管理', icon: '', noCache: true }
  },
  {
    path: '/department',
    component: () => import('@/views/system/department'),
    name: 'department',
    meta: { title: '部门管理', icon: '', noCache: true }
  },
  {
    path: '/project',
    component: () => import('@/views/system/project'),
    name: 'project',
    meta: { title: '项目管理', icon: '', noCache: true },
  },
  {
    path: '/preSalesProject',
    component: () => import('@/views/system/preSalesProject'),
    name: 'preSalesProject',
    meta: { title: '售前项目', icon: '', noCache: true },
  },
  {
    path: '/rate',
    component: () => import('@/views/system/rate'),
    name: 'rate',
    meta: { title: '项目进度', icon: '', noCache: true },
  },
  {
    path: '/process',
    component: () => import('@/views/process/index'),
    name: 'process',
    meta: { title: '流程管理', icon: '', noCache: true },
  },

  {
    path: '/sealStart',
    component: () => import('@/views/operation/seal'),
    name: 'operation',
    meta: { title: '用印', icon: '', noCache: true },
  },
  {
    path: '/invoicStart',
    component: () => import('@/views/operation/invoic'),
    name: 'invoicStart',
    meta: { title: '开票', icon: '', noCache: true },
  },
  {
    path: '/payStart',
    component: () => import('@/views/operation/pay'),
    name: 'payStart',
    meta: { title: '付款', icon: '', noCache: true },
  },
  {
    path: '/bidStart',
    component: () => import('@/views/operation/bid'),
    name: 'bidStart',
    meta: { title: '投标', icon: '', noCache: true },
  },
  {
    path: '/loanStart',
    component: () => import('@/views/operation/loan'),
    name: 'loanStart',
    meta: { title: '借款单', icon: '', noCache: true },
  },
  {
    path: '/contractApproval',
    component: () => import('@/views/operation/contractApproval'),
    name: 'contractApproval',
    meta: { title: '合同审批', icon: '', noCache: true },
  },
  {
    path: '/reimbursement',
    component: () => import('@/views/operation/reimbursement'),
    name: 'reimbursement',
    meta: { title: '员工报销单', icon: '', noCache: true },
  },
  {
    path: '/laborCosts',
    component: () => import('@/views/operation/laborCosts'),
    name: 'laborCosts',
    meta: { title: '劳务费用发放单', icon: '', noCache: true },
  },
  {
    path: '/purchaseRequest',
    component: () => import('@/views/operation/purchaseRequest'),
    name: 'purchaseRequest',
    meta: { title: '采购申请单', icon: '', noCache: true },
  },
  {
    path: '/carStart',
    component: () => import('@/views/operation/car'),
    name: 'carStart',
    meta: { title: '用车申请单', icon: '', noCache: true },
  },
  
  // 采购管理
  {
    path: '/purchase',
    component: () => import('@/views/purchase/resource/index'),
    name: 'purchase',
    meta: { title: '采购管理', icon: '', noCache: true },
  },
  // {
  //   path: '/procurementForm',
  //   component: () => import('@/views/purchase/procurementForm/index'),
  //   name: 'procurementForm',
  //   meta: { title: '采购计划报审表', icon: '', noCache: true },
  // },
  {
    path: '/suppliers',
    component: () => import('@/views/connection/suppliers/index'),
    name: 'suppliers',
    meta: { title: '供应商管理', icon: '', noCache: true },
  },
  {
    path: '/connection',
    component: () => import('@/views/connection/connection/index'),
    name: 'connection',
    meta: { title: '客户管理', icon: '', noCache: true },
  },
  {
    path: '/userInfo',
    component: () => import('@/views/userInfo/index'),
    name: 'userInfo',
    meta: { title: '用户个人信息', icon: '', noCache: true },
  },
  {
    path: '/budget',
    component: () => import('@/views/system/budget'),
    name: 'budget',
    meta: { title: '预算科目管理', icon: '', noCache: true },
  },
  {
    path: '/costBudget',
    component: () => import('@/views/system/costBudget'),
    name: 'costBudget',
    meta: { title: '主要业务收入及成本预算', icon: '', noCache: true },
  },
  {
    path: '/paymentBudget',
    component: () => import('@/views/system/paymentBudget'),
    name: 'paymentBudget',
    meta: { title: '项目收付款预算', icon: '', noCache: true },
  },
  {
    path: '/toDoList',
    component: () => import('@/views/purchase/toDoList/index'),
    name: 'toDoList',
    meta: { title: '待办事项', icon: '', noCache: false },
  },
  {
    path: '/detail',
    component: () => import('@/views/purchase/toDoList/components/detail'),
    name: 'detail',
    meta: { title: '待办详情', icon: '', noCache: true },
  },
  {
    path: '/printing',
    component: () => import('@/views/purchase/toDoList/printing'),
    name: 'printing',
    meta: { showNav: true },
  },
  {
    path: '/test',
    component: () => import('@/views/test/fileImport.vue'),
    name: 'test',
    meta: { title: '测试页面', icon: '', noCache: true },
  },

  //数据导出页面 
  {
    path: '/dataExportIndex',
    component: () => import('@/views/dataExport/index'),
    name: 'dataExportIndex',
    meta: { title: '数据导出', icon: '', noCache: true },
  },

]

export const asyncRouterMap = [
  indexRouter,
  baseInfoRouter,
  managerRouter,
]

const router = createRouter({
  history: createWebHistory(),
  routes: constantRouterMap,
})


export default router;